<template>
	<div class="layout">
		<Split v-model="split">
			<div slot="left" class="demo-split-pane">
				<div class="layout-title">
					<div class="layout-title-left">
						商品套餐导航树
					</div>
					<div class="layout-title-right">
						<Button type="dashed" title="添加商品套餐种类" @click="openCommodityPackageTypeModal"
							style="margin-right:10px;" v-show="permission.isAddCommodityPackageType">
							<Icon type="md-add-circle" size='18'/>
						</Button>
						<Button type="dashed" title="删除商品套餐种类" @click="deleteCommodityPackageType"
							v-show="permission.isDeleteCommodityPackageType">
							<Icon type="md-trash" size='18'/>
						</Button>
					</div>
				</div>

				<Tree :data="treeData" ref="commodityPackageTree" style="margin: 20px 10px;"
					@on-select-change="clickNode">
				</Tree>
			</div>
			<div slot="right" class="demo-split-pane">
				<div class="layout-title">
					<div class="layout-title-left">
						<img src="/static/imgs/shangpintiaocan.png" class="jxyd-imgicon"/>
						商品套餐管理
					</div>
					<div class="layout-title-right">
						<button class="jxyd-button" title="新建套餐" @click="addPackage"
							style="margin-right:10px;" v-show="permission.isAdd">
							<Icon type="md-add-circle" size='18'/> 新建
						</button>
						<a href="javascript:void(0)" style="margin-right: 10px;" @click="handleDownLoad"
							class="jxyd-button" v-show="permission.isExport">
							<Icon type="md-open" size='18'/> 导出
						</a>
						<Dropdown @on-click="batchFunc">
							<a class="jxyd-a">
								批量操作
								<Icon type="ios-arrow-down"></Icon>
							</a>
							<DropdownMenu slot="list">
								<DropdownItem name='batchDele' v-show="permission.isDelete" class="dropdown-item">
									<Icon type="md-trash" size='18'/> 删除
								</DropdownItem>
								<DropdownItem name="createCode" v-show="permission.isCreateCode" class="dropdown-item">
									<Icon type="ios-barcode-outline" size='18'/> 生成条码
								</DropdownItem>
							</DropdownMenu>
						</Dropdown>
					</div>
				</div>

				<div id="layout-box">
					<div id="box-search">
						<Form ref="formSearch" :label-width="70" :model="searchItems" inline>
							<Row :gutter="16">
								<Col :lg="8" :md="24">
								<FormItem label="套餐编号" style="width:100%">
									<Input type="text" v-model="searchItems.code" placeholder="使用扫码枪或手动输入"
										@keyup.enter.native="initListData(1)" icon="md-qr-scanner" />
								</FormItem>
								</Col>
								<Col :lg="8" :md="24">
								<FormItem label="套餐名称" style="width:100%">
									<Input type="text" v-model="searchItems.name" placeholder="请输入套餐名称"
										@keyup.enter.native="initListData(1)" />
								</FormItem>
								</Col>
								<Col :lg="8" :md="24">
								<FormItem label="是否启用" style="width:100%">
									<Select v-model="searchItems.isUse" @on-change="initListData(1)">
										<Option :value="-1" :key="-1">请选择</Option>
										<Option :value="0" :key="0">否</Option>
										<Option :value="1" :key="1">是</Option>
									</Select>
								</FormItem>
								</Col>

							</Row>
							<Row :gutter="16" v-show="advancedSelect">
								<Col :lg="8" :md="24">
								<FormItem label="包含商品" style="width:100%">
									<Input type="text" v-model="searchItems.containCommodity" placeholder="请输入商品名称"
										@keyup.enter.native="initListData(1)" />
								</FormItem>
								</Col>
								<Col :lg="8" :md="24">
								<FormItem label="创建时间" style="width:100%">
									<DatePicker ref="searchCreateDate" type="daterange" show-week-numbers
										placement="bottom-end" placeholder="请选择日期" @on-change='createDateChange'
										style="width:100%">
									</DatePicker>
								</FormItem>
								</Col>
								<Col :lg="8" :md="24">
								<FormItem label="备注" style="width:100%">
									<Input type="text" v-model="searchItems.note" placeholder="请输入备注"
										@keyup.enter.native="initListData(1)" />
								</FormItem>
								</Col>
							</Row>
							<FormItem :label-width="20">
								<button class="jxyd-button jxyd-primary" @click="initListData(1)" style="margin-right:10px;">查询</button>
								<button class="jxyd-button" @click="initSearch" style="margin-right:10px;">重置</button>
								<span @click="advancedSelect = true;" style="color:red;cursor: pointer;"
									v-if="!advancedSelect">
									展开
									<Icon type="ios-arrow-down" size='18'/>
								</span>
								<span @click="foldSearch" style="color:red;cursor: pointer;" v-else>
									折叠
									<Icon type="ios-arrow-up" size='18'/>
								</span>
							</FormItem>
						</Form>
					</div>
					<div id="box-table">
						<Table row-key="guid" ref="package" :columns="tableColumns" :data="packageData"
							@on-selection-change="packageSeleChange"></Table>
					</div>
					<div id="page-box">
						<Page show-sizer :total="packageCount" :page-size="searchItems.pageSize" @on-change="pageChange"
							show-total show-elevator :page-size-opts ='pageSizeOpts' :current="searchItems.pageIndex" @on-page-size-change='pageSizeChange'>
						</Page>
					</div>
				</div>
			</div>
		</Split>

		<Modal v-model="commodityPackageTypeModal" draggable sticky scrollable :styles="{top: '100px'}">
			<p slot="header" class="modal-header">
				<img src="/static/imgs/shangpintiaocan.png" class="jxyd-imgicon"/>
				<span>操作商品种类</span>
			</p>

			<Form ref="commodityPackageTypeform" :model="commodityPackageTypeFormItem" :label-width="70"
				:rules="commodityPackageTypeRuleRole">
				<div style="background-color:#fff;padding:20px;border-radius:5px;">
					<Form-item label="名称" prop="key">
						<Input v-model="commodityPackageTypeFormItem.key" placeholder="请输入" size="large" />
					</Form-item>
					<Form-item label="编号" prop="value">
						<Input v-model="commodityPackageTypeFormItem.value" placeholder="请输入" size="large" />
					</Form-item>
					<Form-item label="备注" prop="note">
						<Input v-model="commodityPackageTypeFormItem.note" type="textarea" placeholder="请输入"
							size="large" />
					</Form-item>
				</div>
			</Form>

			<div slot="footer">
				<Button @click="commodityPackageTypeCancel">取消</Button>
				<Button type="primary" @click="commodityPackageTypeSubmit(1)">保存</Button>
				<Button type="success" @click="commodityPackageTypeSubmit(2)">保存并继续</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import formatDate from '@/utils/formatDate'
	import formatNum from '@/utils/formatNum'
	import dateUtil from '@/utils/dateUtil'
	export default {
		name: 'commoditypackage',
		components: {
		},
		data() {
			return {
				split: 0.2,
				searchItems: {
					code: '',
					name: '',
					type: '',
					containCommodity: '',
					isUse: -1,
					createDate: [],
					discount: 100,
					note: '',
					pageSize: 10,
					pageIndex: 1,
				},
				advancedSelect: false,
				packageCount: 0,
				tableColumns: [{
						type: 'selection',
						width: 60,
						align: 'center',
						fixed: 'left'
					},
					{
						title: '套餐图片',
						key: 'img',
						width: 100,
						render(h, params) {
							return [h('Poptip', {
								attrs: {
									'placement': "right",
									transfer: true
								}
							}, [h('Avatar', {
								style: {
									'width': '40px',
									'height': '40px',
									'cursor': 'pointer'
								},
								attrs: {
									'src': params.row.imgFile.length > 0 ? params.row.imgFile[0]
										.url :
										'/file/file/GetFile?fileName=DefaultCommodity.png&path=/app/Uploads/FIXIMG/DefaultCommodity.png',
								}
							}), h('div', {
								slot: "content"
							}, [h('Avatar', {
								style: {
									'width': '120px',
									'height': '120px'
								},
								attrs: {
									'src': params.row.imgFile.length > 0 ? params.row
										.imgFile[0].url :
										'/file/file/GetFile?fileName=DefaultCommodity.png&path=/app/Uploads/FIXIMG/DefaultCommodity.png',
								}
							})])])];
						}
					},
					{
						title: '套餐条码',
						key: 'code',
						width: 150
					},
					{
						title: '套餐名称',
						key: 'name',
						width: 250,
						render:(h, params)=> {
							return h('a',{
								class:'jxyd-a',
								on: {
								    click: (e) => {
								        this.$router.push({
								        	path: 'packagedetailinfo',
											query: {
												packageId: params.row.id
											}
								        });
								    }
								}
							},params.row.name)
						}
					},
					{
						title: '折扣',
						key: 'discount',
						width: 150
					},
					{
						title: '套餐采购总金额',
						key: 'purchaseAmount',
						width: 200,
					},
					{
						title: '套餐销售总金额',
						key: 'salesAmount',
						width: 200,
					},
					{
						title: '是否启用',
						key: 'isUse',
						width: 200,
						render: (h, params) => {
							return h('i-Switch', {
								attrs: {
									'value': params.row.isUse,
									'disabled': !this.permission.isUpdateUse
								},
								on: {
									'on-change': (e) => {
										params.row.isUse = e;
										let self = this;
										let tag = '';
										if (e) {
											tag = '启用';
										} else {
											tag = '停用';
										}
										this.$Modal.confirm({
											title: "操作警告",
											content: "是否确认" + tag + "“" + params.row.name +
												"”套餐？",
											onOk() {
												request.get('/api/CommodityPackage/EditUse', {
													params: {
														id: params.row.id,
														isUse: e
													}
												}).then(function(response) {
													if (response.state == 0) {
														self.$Notice.error({
															title: '错误提示',
															duration: 3,
															desc: '更新失败:' +
																response
																.errorMsg
														});
														return;
													}
													self.$Notice.success({
														title: '正确提示',
														duration: 3,
														desc: '更新成功!'
													});
												}).catch(function(error) {
													params.row.isUse = !e;
												})
											},
											onCancel() {
												params.row.isUse = !e;
											}
										});
									}
								}
							})
						}
					},
					{
						title: '创建时间',
						key: 'createDate',
						width: 200,
						render: (h, params) => {
							return h('span', {}, formatDate(new Date(params.row.createDate), 'yyyy-MM-dd'));
						}
					},
					{
						title: '备注',
						key: 'note',
						width: 400
					},
					{
						title: '操作',
						key: 'action',
						width: 100,
						align: 'center',
						fixed: 'right',
						render: (h, params) => {
							var btnArr = [];
							if (this.permission.isEdit) {
								btnArr.push(h('a', {
									class:'jxyd-a',
									on: {
										click: (e) => {
											this.$router.push({
												path: 'packagefunc',
												query: {
													packageId: params.row.id
												}
											});
										}
									},
								}, "编辑"));
							}
							return btnArr;
						}
					}
				],
				packageData: [],
				tableRowIds: [],
				tableRowObjs:[],
				permission: {
					isAdd: false,
					isEdit: false,
					isDelete: false,
					isExport: false,
					isUpdateUse: false,
					isAddCommodityPackageType: false,
					isDeleteCommodityPackageType: false,
					isCreateCode: false
				},
				commodityPackageTypePid: 'sptczl',
				commodityPackageTypeModal: false,
				commodityPackageTypeFormItem: {
					id: 0,
					key: '',
					value: '',
					note: '',
					pid: 0,
					pcode:'',
					creator: parseInt(localStorage.getItem("userId"))
				},
				commodityPackageTypeRuleRole: {
					key: [{
							required: true,
							message: '请填写种类名',
							trigger: 'blur'
						},
						{
							type: 'string',
							max: 20,
							message: '输入不得大于20个字',
							trigger: 'blur'
						}
					],
					value: [{
							required: true,
							message: '请填写编号',
							trigger: 'blur'
						},
						{
							type: 'string',
							max: 20,
							message: '输入不得大于20个字',
							trigger: 'blur'
						}
					],
					note: [{
							required: false,
							message: '请填写备注',
							trigger: 'blur'
						},
						{
							type: 'string',
							max: 50,
							message: '输入不得大于50个字',
							trigger: 'blur'
						}
					]
				},
				treeData: [],
				pageSizeOpts:[10,20,30,40,50,60,70,80,90,100]
			}
		},
		methods: {
			initListData(index) {
				let self = this;
				self.searchItems.pageIndex = index;
				request.post('/api/CommodityPackage/GetCommodityPackage', self.searchItems).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取数据失败：" + response.errorMsg
						});
						return;
					}

					self.packageData = response.data.commodityPackage;
					self.packageCount = response.data.count;
				}).catch(function(error) {})
			},
			packageSeleChange(items) {
				this.tableRowIds = [];
				this.tableRowObjs = [];
				for (var i = 0; i < items.length; i++) {
					this.tableRowObjs.push(items[i]);
					this.tableRowIds.push(items[i].id);
				}
			},
			deletePackage() {
				if (this.tableRowIds.length <= 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '没有选中记录！'
					});
					return;
				}
				var self = this;
				this.$Modal.confirm({
					title: "操作警告",
					content: "套餐删除后不可恢复，是否继续操作？",
					onOk() {
						request.post('/api/CommodityPackage/DeleCommodityPackage', self.tableRowIds).then(function(
							response) {

							if (response.state == 0) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: response.errorMsg
								});
								return;
							}

							self.initListData(1);
							self.tableRowIds = [];
							self.tableRowObjs= [];
						}).catch(function(error) {})
					},
					onCancel() {}
				});
			},
			pageChange(index) {
				this.initListData(index);
			},
			pageSizeChange(pageSize){
				this.searchItems.pageSize = pageSize;
				this.initListData(1);
			},
			foldSearch() {
				this.advancedSelect = false;
				this.$refs.searchCreateDate.handleClear();
				this.$refs.searchCreateDate.handleClear();
				this.searchItems.note = '';
				this.searchItems.containCommodity = '';
			},
			initSearch() {
				this.searchItems.code = '';
				this.searchItems.name = '';
				this.searchItems.isUse = -1;
				this.searchItems.containCommodity = '';
				this.searchItems.note = '';
				this.$refs.searchCreateDate.handleClear();
			},
			addPackage() {
				this.$router.push({
					path: 'packagefunc'
				});
			},
			createDateChange(val) {
				if (val[0]) {
					this.searchItems.createDate = val;
				} else {
					this.searchItems.createDate = [];
				}
			},
			initPermission() {
				let self = this;
				let params = {
					funcCodes: ['CommodityPackage.AddCommodityPackageType',
						'CommodityPackage.DeleteCommodityPackageType', 'CommodityPackage.Add',
						'CommodityPackage.Edit', 'CommodityPackage.Delete', 'CommodityPackage.Export',
						'CommodityPackage.UpdateUse', 'CommodityPackage.CreateCode'
					],
					userId: parseInt(localStorage.getItem("userId"))
				};
				request.post('/api/Function/VerifyPermissions', params).then(function(response) {
					let tipTimeoutCount = localStorage.getItem("_tipTimeoutCount")
					if(tipTimeoutCount != undefined){
						tipTimeoutCount = parseInt(tipTimeoutCount);
					}
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取权限数据失败：" + response.errorMsg
						});
						return;
					}else if(response.state == 2 && (tipTimeoutCount == undefined || tipTimeoutCount >= 1000)){
						self.$Modal.warning({
							title:'系统到期提示',
							content: response.errorMsg,
							onOk:() => {
								localStorage.setItem("_tipTimeoutCount",1);
							}
						});
					}
					if(tipTimeoutCount == undefined || tipTimeoutCount < 1000){
						localStorage.setItem("_tipTimeoutCount",tipTimeoutCount == undefined ? 1 : tipTimeoutCount+1)
					}
					for (var i = 0; i < response.data.length; i++) {
						switch (response.data[i].funcCode) {
							case 'CommodityPackage.AddCommodityPackageType':
								self.permission.isAddCommodityPackageType = response.data[i].permission
								break;
							case 'CommodityPackage.DeleteCommodityPackageType':
								self.permission.isDeleteCommodityPackageType = response.data[i].permission
								break;
							case 'CommodityPackage.Add':
								self.permission.isAdd = response.data[i].permission
								break;
							case 'CommodityPackage.Edit':
								self.permission.isEdit = response.data[i].permission
								break;
							case 'CommodityPackage.Delete':
								self.permission.isDelete = response.data[i].permission
								break;
							case 'CommodityPackage.Export':
								self.permission.isExport = response.data[i].permission
								break;
							case 'CommodityPackage.UpdateUse':
								self.permission.isUpdateUse = response.data[i].permission
								break;
							case 'CommodityPackage.CreateCode':
								self.permission.isCreateCode = response.data[i].permission
								break;
						}
					}
				}).catch(function(error) {})
			},
			handleDownLoad() {
				let self = this;
				this.$Modal.confirm({
					title: "操作警告",
					content: "是否导出列表数据？",
					onOk() {
						fetch('/api/Util/ExportCommodityPackageExcel', {
								method: 'GET',
								headers: new Headers({
									'Authorization': window.localStorage.getItem('token'),
									'Schema': window.localStorage.getItem('schema'),
									'WorkShop':window.localStorage.getItem('workshop')
								}),
							})
							.then(res => res.blob())
							.then(data => {
								const blobUrl = window.URL.createObjectURL(data);
								self.download(blobUrl, '套餐商品.xlsx');
							});
					},
					onCancel() {}
				});
			},
			download(blobUrl, name) {
				const a = document.createElement('a');
				a.download = name;
				a.href = blobUrl;
				a.click();
			},
			commodityPackageTypeCancel() {
				this.initTreeData();
				this.commodityPackageTypeModal = false;
			},
			commodityPackageTypeSubmit(type) {
				this.$refs["commodityPackageTypeform"].validate((valid) => {
					if (valid) {
						let self = this;
						if (!self.commodityPackageTypeFormItem.pcode) {
							self.commodityPackageTypeFormItem.pcode = self.$refs.commodityPackageTree
								.getSelectedNodes()[0].value;
						}
						if (self.commodityPackageTypeFormItem.id < 1) {
							for (var i = 0; i < self.treeData[0].children.length; i++) {
								if (self.treeData[0].children[i].title == self.commodityPackageTypeFormItem.key) {
									self.$Notice.error({
										title: '错误提示',
										duration: 3,
										desc: '商品种类名已存在!'
									});
									return;
								}
							}
						}
						request.post('/api/DataDictionary/AddDataDictionary', self.commodityPackageTypeFormItem)
							.then(function(response) {
								if (response.state == 0) {
									self.$Notice.error({
										title: '错误提示',
										duration: 3,
										desc: '保存失败:' + response.errorMsg
									});
									return;
								}

								self.$Notice.success({
									title: '正确提示',
									duration: 3,
									desc: '保存成功!'
								});

								self.initTreeData();
								if (type == 1) {
									self.commodityPackageTypeModal = false;
								} else {
									let pid = self.commodityPackageTypeFormItem.pcode;
									self.$refs["commodityPackageTypeform"].resetFields();
									self.commodityPackageTypeFormItem.pcode = pid;
								}
							}).catch(function(error) {})
					}
				})
			},
			openCommodityPackageTypeModal() {
				let treeNode = this.$refs.commodityPackageTree.getSelectedNodes();
				if (treeNode.length <= 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '请选择要添加种类的父级！'
					});
					return;
				}
				this.commodityPackageTypeModal = true;
				this.$refs["commodityPackageTypeform"].resetFields();
				this.commodityPackageTypeFormItem.pcode = ''
			},
			deleteCommodityPackageType() {
				let treeNode = this.$refs.commodityPackageTree.getSelectedNodes();
				if (treeNode.length <= 0 || treeNode[0].value == this.commodityPackageTypePid) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '请选中要删除的商品套餐种类！'
					});
					return;
				}
				if (treeNode[0].children.length > 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '当前种类下还有子种类，不可删除！'
					});
					return;
				}
				for (var i = 0; i < this.packageData.length; i++) {
					if (treeNode[0].path.indexOf(this.packageData[i].type) > -1) {
						this.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '当前种类下还有商品套餐，不可删除！'
						});
						return;
					}
				}
				var self = this;
				this.$Modal.confirm({
					title: "操作警告",
					content: "商品套餐种类删除后不可恢复，是否继续操作？",
					onOk() {
						request.post('/api/DataDictionary/DeleDataDictionary', [treeNode[0].id]).then(function(
							response) {
							if (response.state == 0) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: response.errorMsg
								});
								return;
							}
							self.initTreeData();
							self.$Notice.success({
								title: '正确提示',
								duration: 3,
								desc: '删除成功!'
							});
						}).catch(function(error) {})
					},
					onCancel() {}
				});
			},
			initTreeData() {
				let self = this;
				request.get('/api/DataDictionary/GetTreeOfDataDictionary', {
					params: {
						code: self.commodityPackageTypePid
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取导航树数据失败：" + response.errorMsg
						});
						return;
					}
					self.treeData = response.data;
					self.initTreeNode(self.treeData);
				}).catch(function(error) {})
			},
			initTreeNode(treeData) {
				for (let i = 0; i < treeData.length; i++) {
					treeData[i].render = (h, {
						root,
						node,
						data
					}) => {
						return h('div', {
							style: {
								'display':'flex',
								'height':'22px',
								'line-height':'22px'
							}
						}, [
							h('img', {
								style: {
									'width':'22px',
									'height':'22px'
								},
								attrs: {
									src: "/static/imgs/shangpintiaocan.png"
								}
							}),
							h('span', {
								style: {
									cursor: 'pointer',
									backgroundColor: node.node.selected ? "#d5e8fc" : "transparent"
								},
								attrs: {
									class: `ivu-tree-title`
								},
								on: {
									click: (e) => {
										if (!node.node.selected) {
											this.$refs.menuTree.handleSelect(node.nodeKey);

										}
									}
								}
							}), data.title
						]);

					};
					if (treeData[i].children && treeData[i].children.length > 0) {
						this.initTreeNode(treeData[i].children);
					}
				}
			},
			clickNode() {
				let treeNode = this.$refs.commodityPackageTree.getSelectedNodes();
				if (treeNode.length <= 0) {
					return;
				}
				if (treeNode[0].title != '商品套餐种类') {
					this.searchItems.type = treeNode[0].title;
				} else {
					this.searchItems.type = '';
				}
				this.initListData(1);
			},
			createCode() {
				if (this.tableRowIds.length <= 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '没有选中记录！'
					});
					return;
				}
				let selectedData = {
					name: 'package',
					attributes: [{
						name: 'name',
						displayName: '套餐名'
					},{
						name: 'unit',
						displayName: '计量单位'
					},{
						name: 'type',
						displayName: '套餐种类'
					},{
						name: 'discount',
						displayName: '套餐折扣'
					},{
						name: 'outPrice',
						displayName: '套餐售价'
					},{
						name: 'note',
						displayName: '商品备注'
					}],
					printData: this.tableRowObjs
				}
				localStorage.setItem('_printData', JSON.stringify(selectedData));
				this.$router.push({
					path: 'printercodepage'
				});
			},
			batchFunc(name) {
				switch (name) {
					case 'batchDele':
						this.deletePackage()
						break;
					case 'createCode':
						this.createCode()
						break;
				}
			}
		},
		watch: {},
		created: function() {
			this.initPermission();
			this.initTreeData();
			this.initListData(1);
		}
	}
</script>

<style scoped>
	.layout {
		background: #fff;
		border-radius: 8px;
		height: 100%;
	}

	.layout-title {
		overflow: hidden;
		padding: 10px;
		font-size: 16px;
		border-bottom: 1px solid #e8eaec;
	}

	#box-search {
		padding-top: 20px;
	}

	.layout-title-left {
		float: left;
		height: 32px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.layout-title-right {
		float: right;
	}

	#page-box {
		margin-top: 20px;
		text-align: center;
	}

	.key {
		text-align: center;
		width: 15%;
		color: #353535;
		font-weight: 400;
	}

	.ivu-select-selection {
		border: none !important;
		outline: none !important;
		height: 15px;
		padding-left: 0px;
	}

	.icon-btn {
		float: right;
		cursor: pointer;
		margin-left: 15px;
		background-color: #F8F8F8;
	}

	.ivu-modal-header p,
	.ivu-modal-header-inner {
		height: auto;
	}

	.time {
		font-size: 14px;
		font-weight: bold;
	}

	.content {
		padding-left: 5px;
	}

	.selectBox /deep/ div {
		border: none !important;
	}

	.demo-split-pane {
		height: 100%;
		padding: 0px 20px 10px 20px;
		overflow-y: auto;
	}
	
	.dropdown-item{
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.modal-header{
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
</style>